import { render } from "./BuildTheSkills.vue?vue&type=template&id=b1bb8714&scoped=true"
import script from "./BuildTheSkills.vue?vue&type=script&lang=js"
export * from "./BuildTheSkills.vue?vue&type=script&lang=js"

import "./BuildTheSkills.vue?vue&type=style&index=0&id=b1bb8714&lang=scss&scoped=true"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1bb8714"]])

export default __exports__